/**
 * Precomputed audiogram data for the "Hear it" pane's waveform — 240
 * normalized RMS peaks (0.084–1.0) extracted offline from the actual audio
 * file (killer_trailer_v7_audio.m4a, 3:05 — 184.95s). Used directly by the waveform in
 * ShowcaseRowV3.tsx (no Web Audio AnalyserNode against the S3 file — that
 * hits CORS); the played/unplayed fill is driven by the audio element's
 * currentTime/duration instead.
 */
export const RACHEL_AUDIO_PEAKS: number[] = [
  0.75, 0.76, 0.906, 0.692, 0.734, 0.601, 1.0, 0.711, 0.647, 0.728, 0.971, 0.635,
  0.995, 0.34, 0.346, 0.2, 0.436, 0.465, 0.386, 0.386, 0.317, 0.185, 0.449, 0.391,
  0.416, 0.245, 0.304, 0.448, 0.377, 0.124, 0.451, 0.306, 0.273, 0.312, 0.389, 0.409,
  0.405, 0.466, 0.385, 0.303, 0.364, 0.349, 0.387, 0.389, 0.256, 0.368, 0.119, 0.526,
  0.421, 0.372, 0.176, 0.485, 0.271, 0.433, 0.244, 0.382, 0.333, 0.466, 0.261, 0.386,
  0.21, 0.281, 0.384, 0.328, 0.54, 0.273, 0.366, 0.328, 0.365, 0.431, 0.415, 0.084,
  0.451, 0.489, 0.326, 0.185, 0.425, 0.229, 0.357, 0.322, 0.406, 0.427, 0.319, 0.369,
  0.129, 0.501, 0.409, 0.343, 0.344, 0.37, 0.335, 0.285, 0.369, 0.323, 0.466, 0.386,
  0.387, 0.365, 0.419, 0.345, 0.365, 0.391, 0.309, 0.394, 0.249, 0.391, 0.425, 0.257,
  0.463, 0.265, 0.18, 0.493, 0.357, 0.361, 0.363, 0.492, 0.435, 0.382, 0.425, 0.353,
  0.244, 0.435, 0.348, 0.317, 0.24, 0.393, 0.437, 0.288, 0.419, 0.261, 0.329, 0.493,
  0.366, 0.277, 0.369, 0.362, 0.218, 0.291, 0.134, 0.391, 0.409, 0.441, 0.381, 0.333,
  0.343, 0.416, 0.478, 0.327, 0.331, 0.259, 0.35, 0.39, 0.336, 0.331, 0.425, 0.312,
  0.443, 0.42, 0.351, 0.363, 0.415, 0.274, 0.416, 0.291, 0.288, 0.367, 0.277, 0.429,
  0.411, 0.38, 0.262, 0.388, 0.385, 0.274, 0.416, 0.261, 0.333, 0.392, 0.21, 0.322,
  0.509, 0.355, 0.339, 0.232, 0.409, 0.392, 0.331, 0.396, 0.285, 0.185, 0.42, 0.308,
  0.367, 0.436, 0.356, 0.468, 0.354, 0.396, 0.377, 0.372, 0.394, 0.384, 0.397, 0.383,
  0.341, 0.598, 0.543, 0.465, 0.336, 0.386, 0.432, 0.436, 0.204, 0.44, 0.337, 0.428,
  0.27, 0.349, 0.403, 0.093, 0.454, 0.385, 0.16, 0.442, 0.26, 0.352, 0.402, 0.217,
  0.461, 0.376, 0.332, 0.156, 0.377, 0.183, 0.418, 0.274, 0.373, 0.262, 0.334, 0.21,
];
